export default __webpack_public_path__ + "static/media/Flag of South Georgia and South Sandwich Islands.8b4f116a.gif";